import styled from 'styled-components';
import { space } from 'styled-system';

import { Box } from '@hivebrite/design-system/Box';

import { EventWebinarUrl } from 'hb-react/shared/apps/Events/components/EventDetailsContainer/components/EventWebinarUrl';
import EventDate from 'hb-react/shared/components/EventDate';
import useTimeZoneConfiguration from 'hb-react/shared/hooks/useTimeZoneConfiguration';
import TwoDigitsCalendar from 'hb-react/shared/icons/dynamic/TwoDigitsCalendar';

const twoDigitsCalendarSize = 40;

export const Details = ({
  startDate,
  timezone,
  endDate,
  locations,
  webinarUrl,
  showWebinarUrl,
}) => {
  const timeZoneConfiguration = useTimeZoneConfiguration();

  return (
    <Box flexDirection="column">
      <DetailBox
        display={{ _: 'flex', m: 'none', l: 'flex' }}
        mb={{ _: 1, m: 2 }}
      >
        <Ellipsis>
          <Box as="span" display="inline" fontWeight={2}>
            {__('Date:')}{' '}
          </Box>
          <EventDate
            as="span"
            event={{ start_date: startDate, end_date: endDate, timezone }}
            timezoneConfiguration={timeZoneConfiguration}
          />
        </Ellipsis>
      </DetailBox>
      {locations?.address && (
        <DetailBox mb={{ _: 1, m: 2 }}>
          <Ellipsis>
            <Box as="span" display="inline" fontWeight={2}>
              {__('Location:')}{' '}
            </Box>{' '}
            {locations.address}
          </Ellipsis>
        </DetailBox>
      )}
      {webinarUrl && (
        <DetailBox mb={{ l: 1 }}>
          <Box as="span" display="inline" fontWeight={2}>
            {__('Online event')}
            {showWebinarUrl ? ':' : ''}
          </Box>
          <EventWebinarUrl
            webinar_url={webinarUrl}
            show_webinar_url={showWebinarUrl}
          />
        </DetailBox>
      )}
    </Box>
  );
};

export const HeaderRow = ({ day, title, startDate, endDate, timezone }) => {
  const timeZoneConfiguration = useTimeZoneConfiguration();

  return (
    <Box alignItems="center">
      <ShadowedWrapper flexGrow="0" color="primary">
        <TwoDigitsCalendar
          width={twoDigitsCalendarSize}
          height={twoDigitsCalendarSize}
          day={day}
        />
      </ShadowedWrapper>
      <DetailBox flexDirection="column" ml={3}>
        <DetailBox mb={1} font="h3-semibold">
          <Ellipsis>{title}</Ellipsis>
        </DetailBox>
        <DetailBox>
          <Ellipsis>
            <Box as="span" display="inline" fontWeight={2}>
              {__('Date:')}{' '}
            </Box>
            <EventDate
              as="span"
              event={{ start_date: startDate, end_date: endDate, timezone }}
              timeZoneConfiguration={timeZoneConfiguration}
            />
          </Ellipsis>
        </DetailBox>
      </DetailBox>
    </Box>
  );
};

export const HeaderColumn = ({ day, title }) => (
  <Box mb={3} alignItems="center">
    <ShadowedWrapper flex="content" flexGrow="0" color="primary">
      <TwoDigitsCalendar width={40} height={40} day={day} />
    </ShadowedWrapper>
    <Box
      display="block"
      font="h3-semibold"
      ml={3}
      overflow="hidden"
      style={{ textOverflow: 'ellipsis' }}
      width={`calc(100% - ${twoDigitsCalendarSize}px - 12px)`}
    >
      {title}
    </Box>
  </Box>
);

const ShadowedWrapper = styled(Box)`
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 6px;
`;

const DetailBox = styled(Box)`
  min-width: 0;
`;

const Ellipsis = styled.span`
  ${space}
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
